"use client";

// Site-wide broken-image guard. A capture-phase 'error' listener catches ANY
// <img> that fails to load — including images inside dangerouslySetInnerHTML
// (the article product cards) that React can't attach onError to — and swaps it
// to a clean placeholder. The data-fallback guard prevents an infinite loop if
// the placeholder itself were ever missing.

import { useEffect } from "react";

const PLACEHOLDER = "/placeholder-product.svg";

export default function GlobalImageFallback() {
  useEffect(() => {
    const onError = (e: Event) => {
      const t = e.target as HTMLElement | null;
      if (!t || t.tagName !== "IMG") return;
      const img = t as HTMLImageElement;
      if (img.dataset.fallbackApplied) return;
      if (img.src.endsWith(PLACEHOLDER)) return;
      img.dataset.fallbackApplied = "1";
      img.src = PLACEHOLDER;
      img.srcset = "";
      img.classList.add("apnl-img-fallback");
    };
    document.addEventListener("error", onError, true); // capture: img errors don't bubble
    return () => document.removeEventListener("error", onError, true);
  }, []);

  return null;
}
